<script>
	import Navbar from "./components/Navbar.svelte";
	import Footer from "./components/Footer.svelte";
	import PullEntitySets from "./create-study-components/PullEntitySets.svelte";
	import FeedType from "./create-study-components/FeedType.svelte";
	import EntitySetsCards from "./create-study-components/EntitySetsCards.svelte";
	import Buttons from "./create-study-components/Buttons.svelte";
	import Interventions from "./create-study-components/Interventions.svelte";
	import Algorithms from "./create-study-components/Algorithms.svelte";
	import PostExpQuestionnaires from "./create-study-components/PostExpQuestionnaires.svelte";
	import Instructions from "./create-study-components/Instructions.svelte";
	import Consent from "./create-study-components/Consent.svelte";
	import CustomEndMsg from "./create-study-components/CustomEndMsg.svelte";
	import Platform from "./create-study-components/Platform.svelte";
	import SecretCodeSubmit from "./create-study-components/SecretCodeSubmit.svelte";
	

	let conditions;
	let conditionsCurrent; // num of conditions
	let submitColor = "#333333";
	let showSections = false;
	let showParamMsg = false;

	const getStorage = () => {
		let conditions = localStorage.getItem("createStudyConditions");
		if (conditions) {
			conditions = Number(conditions);
		} else {
			conditions = 1;
			conditionsCurrent = conditions;
		}
		let params = localStorage.getItem("createStudyParams");
		if (params) {
			showParamMsg = true;
		} else {
			showParamMsg = false;
		}
		return conditions;
	};
	conditions = getStorage();
	$: if (conditions <= 0) conditions = "";
	$: if (conditions != getStorage()) {
		submitColor = "red";
	} else {
		submitColor = "#333333";
	}

	const updateStorage = (conditions) => {
		if (conditions <= 0) conditions = 1;
		conditionsCurrent = conditions;
		localStorage.setItem("createStudyConditions", conditions);
		console.log("conditions requested:", conditions);
	};

	const handleClickCondition = () => {
		updateStorage(conditions);
		submitColor = "#333333";
		showSections = true;
	};

	const handleReset = () => {
		localStorage.setItem("createStudyConditions", 1);
		localStorage.removeItem("createStudyParams");
		localStorage.removeItem("createStudyParamsSelected");
		localStorage.removeItem("createStudyConditionSettings");
		conditions = getStorage();
		showSections = false;
		showParamMsg = false;
		console.log("conditions requested:", conditions);
	};
</script>

<Navbar />

<h1>Specify study parameters</h1>

<PullEntitySets />

<section>
	<label for="conditions-n"><h3>How many conditions?</h3></label>
	<input
		name="condition-n"
		type="number"
		bind:value={conditions}
		min="1"
		style="width:89px"
	/>

	<button
		disabled={false}
		on:click|preventDefault={handleClickCondition}
		style="color:{submitColor};"
	>
		Enter</button
	>
	<button disabled={false} on:click|preventDefault={handleReset}>
		Reset</button
	>
	<p />
</section>

{#if showSections}
	{#if showParamMsg}
		<p>
			If you've recently completed the form, previous values may be
			auto-filled below. To clear the form, click the <strong
				>Reset</strong
			> button above.
		</p>
	{/if}

	<!-- components -->
	<FeedType conditions={conditionsCurrent}/>
	<EntitySetsCards conditions={conditionsCurrent} />
	<Buttons conditions={conditionsCurrent} />
	<Interventions conditions={conditionsCurrent} />
	<Algorithms conditions={conditionsCurrent} />
	<CustomEndMsg conditions={conditionsCurrent} />
	<PostExpQuestionnaires conditions={conditionsCurrent} />
	<Instructions conditions={conditionsCurrent} />
	<Consent conditions={conditionsCurrent} />
	<Platform conditions={conditionsCurrent} />
	<SecretCodeSubmit conditions={conditionsCurrent} />
{/if}

<Footer />
